export default __webpack_public_path__ + "static/media/ic_main_0.ed752fae.png";